module.exports = __webpack_public_path__ + "static/img/14000306.aa51bf15.png";